<template>
  <div>
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
        <form class="form-horizontal">
          <div class="p-grid">
            <div class="p-col">
              <!-- <Button class="p-button-raised" style="float:right;" @click.prevent="openBasic"
              icon="pi pi-plus"/> -->
              <Button class="p-button p-component p-button-success addNewBtn width-auto"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
            </div>
          </div>
        <Dialog header="Sales Bill Sundry" :visible.sync="displayBasic"
           :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">

           <div class="p-fluid p-formgrid p-grid">
             <div class="p-field p-col-12 p-md-6">
              <label for="name">Name<span style="color:red;">*</span></label>
              <InputText v-model.trim="name" id="name"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
               <label for="head">Apply Vat</label>
               <div class="p-field p-col-12 p-md-6">
                 <Checkbox id="vat"   v-model="vat" :binary="true"/>
               </div>
             </div>
             <div class="p-field p-col-12 p-md-6">
               <label for="head">Debit Account</label>
               <Dropdown
                  v-model="debitAccountId"
                  :options="accountMasterList"
                  optionLabel="name" :filter="true"
                  placeholder="Select Debit Account"
                  :showClear="true"
                />
             </div>
            <div class="p-field p-col-12 p-md-6">
               <label for="head">Credit Account</label>
               <Dropdown
                  v-model="creditAccountId"
                  :options="accountMasterList"
                  optionLabel="name" :filter="true"
                  placeholder="Select Credit Account"
                  :showClear="true"
                />
             </div>

          </div>
        <template #footer>
          <Button class="p-button-raised" @click.prevent="addExtraExpenses"
             :label="!this.editing?'Add':'Update'"/>
             <Button class="p-button-raised p-button-info"
            @click.prevent="addAndNewExtraExpenses" v-if="!editing"
             label="Add & New"/>
          <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
        </template>
      </Dialog>
        </form>
      </div>
</template>
<script>
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'measurementUnit',
  data() {
    return { name: '',
      costing: false,
      vat: false,
      extreExpenses: {},
      message: '',
      messageType: '',
      creditAccountId: null,
      debitAccountId: null,
      editing: false,
      displayBasic: false,
      position: 'center',
      id: '',
      show: false,
      loading: false
    }
  },
  computed: {
    accountMasterList() {
      return this.$store.state.accountMaster.accountMasterLists
    }
  },
  mounted() {
    this.accountList()
  },
  methods: {
    async addExtraExpenses() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.creditAccountId === '' || this.creditAccountId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select credit account!', life: 10000})
        return
      }
      let response = ''
      if (this.debitAccountId === null) {
        this.debitAccountId = 0
      }
      let extreExpenses = {
        expensesName: this.name,
        applyVat: this.vat,
        debitAccountId: this.debitAccountId.id,
        creditAccountId: this.creditAccountId.id,
        id: this.id
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createSalesBillSundary', extreExpenses)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updatePurchaseSundary', extreExpenses)
        this.loading = false
      }
      this.responseMessage(response)
      this.closeBasic()
    },
    async addAndNewExtraExpenses() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.creditAccountId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select debit account!', life: 10000})
        return
      }
      let response = ''
      let extreExpenses = {
        expensesName: this.name,
        applyVat: this.vat,
        debitAccountId: this.debitAccountId.id,
        creditAccountId: this.creditAccountId.id,
        id: this.id
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createSalesBillSundary', extreExpenses)
      this.loading = false
      this.responseMessage(response)
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async accountList() {
      await this.$store.dispatch('loadOfficeAccountListForDropdown')
    },
    cancel() {
      this.show = false
      this.editing = false
      this.reset()
      this.closeBasic()
    },
    editExtraExpenses(data) {
      this.editing = true
      this.name = data.expensesName
      this.vat = data.applyVat
      this.id = data.id
      if (data.drAccountId === undefined) {
        this.debitAccountId = ''
      } else {
        this.debitAccountId = data.drAccountId
      }
      if (data.crAccountId === undefined) {
        this.crAccountId = ''
      } else {
        this.creditAccountId = data.crAccountId
      }
      this.openBasic()
    },
    reset() {
      this.name = ''
      this.costing = false
      this.vat = false
      this.debitAccountId = ''
      this.creditAccountId = ''
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    Checkbox,
    Dropdown,
    Dialog,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// billSundrySalesDialog.vue?3c47871d